import React, {useState, useCallback} from 'react';

export default ({subMacro, macro}) => {
    let {parameter} = subMacro; 
    let {context} = parameter; 
    let {subDevice, effect, liveEffect, midiEffect, instrument} = context; // the effect
    subDevice = subDevice || effect || liveEffect || midiEffect || instrument;
    let [min, setMin] = useState(subMacro.min);
    let [max, setMax] = useState(subMacro.max);

    const unmapMacro = useCallback(() => {
        macro.unmapParameter(parameter);
    }, [macro, parameter]);

    const onChangeMin = useCallback(e => {
        let value = e.target.value;
        value = parseFloat(value);
        if (parameter.isValidValue(value)) {
            // check if valid
            subMacro.min = value;
            setMin(e.target.value);
        } else if (e.target.value === '' ||
                  e.target.value === '.') {
            setMin(e.target.value);
        } else {
        }
    }, [setMin]);

    const onChangeMax = useCallback(e => {
        let value = e.target.value;
        value = parseFloat(value);
        if (parameter.isValidValue(value)) {
            // check if valid
            subMacro.max = value;
            setMax(e.target.value);
        } else if (e.target.value === '' ||
                  e.target.value === '.') {
            setMax(e.target.value);
        } else {
        }
    }, [setMax]);

    return (
        <div className="sub-macro">
          <div className="sub-field effect">
            {subDevice ? subDevice.name : effect ? effect.name :
             instrument ? instrument.name : ''}
          </div>
          <div className="sub-field parameter">
            {parameter.name}
          </div>
          <div className="sub-field">
            <input
              className="min-field"
              onChange={onChangeMin}
              value={min}
              type="text">
            </input>
          </div>
          <div className="sub-field">
            <input
              className="max-field"
              onChange={onChangeMax}
              value={max}
              type="text">
            </input>
          </div>
          <div onClick={unmapMacro} className="unmap-button">
            x
          </div>
        </div>
    );
};
